export default function About() {
  const features = [
    { icon: "ri-refresh-line", title: "全天实时更新", desc: "热点发酵不停更，让你不错过任何关键节点。" },
    { icon: "ri-database-2-line", title: "全网口径汇总", desc: "综合媒体报道与官方声明，多信源交叉梳理。" },
    { icon: "ri-honour-line", title: "客观中立呈现", desc: "只还原事实脉络，不站队、不渲染、不跟风。" },
    { icon: "ri-eye-line", title: "一页吃遍全场", desc: "聚合式信息流，告别在多个平台来回切换的疲惫。" },
  ];

  const numbers = [
    { n: "1200+", l: "单日收录热点" },
    { n: "50+", l: "常驻信息源" },
    { n: "6 类", l: "内容板块划分" },
    { n: "99%", l: "信息可溯源" },
  ];

  return (
    <section id="about" className="w-full scroll-mt-20 bg-background-100/70">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <p className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-heart-line" aria-hidden="true"></i> 关于我们
            </p>
            <h2 className="font-display mt-3 text-2xl md:text-4xl text-foreground-950">我们只做一件事：把瓜端上桌</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              吃瓜网上是一个面向全网网友的热点聚合与浏览页面。我们相信，与其让每个人在不同平台之间来回奔波地拼凑信息，
              不如把散落在各处的热门事件、焦点话题和最新进展，按真实热度统一汇总到眼前。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              我们关注事件本身，也关注事件背后的讨论。在提供「今日热榜」快速掌握风向的同时，
              也通过「深度盘点」和「今日瓜历」帮助你把来龙去脉看得更清楚——做一个帮你吃得明白、看得安心的资讯聚合页。
            </p>

            <dl className="mt-7 grid grid-cols-2 gap-4">
              {numbers.map((s) => (
                <div key={s.l} className="rounded-2xl border border-background-200/70 bg-background-50 p-4">
                  <dd className="font-display text-2xl text-primary-600">{s.n}</dd>
                  <dt className="mt-1 text-xs text-foreground-600">{s.l}</dt>
                </div>
              ))}
            </dl>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((f) => (
              <div key={f.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700 text-xl">
                  <i className={f.icon} aria-hidden="true"></i>
                </span>
                <h3 className="mt-3 text-base font-medium text-foreground-900">{f.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}